import { render } from "./MapaSv.vue?vue&type=template&id=3e3b2490&scoped=true"
import script from "./MapaSv.vue?vue&type=script&lang=ts"
export * from "./MapaSv.vue?vue&type=script&lang=ts"

import "./MapaSv.vue?vue&type=style&index=0&id=3e3b2490&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3e3b2490"

export default script